"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const clients = [{
  id: 2,
  name: "SafeRemove",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604417/img/safe_remove_trust_logo.png"
}, {
  id: 3,
  name: "EcoDestruct",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604417/img/eco_destruct_trust_logo.png"
}, {
  id: 4,
  name: "ProAsbest",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604417/img/pro_asbest_trust_logo.png"
}, {
  id: 5,
  name: "CertiAsbest",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604417/img/certi_asbest_trust_logo.png"
}, {
  id: 6,
  name: "SloopExpert",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604417/img/sloop_expert_partner_logo.png"
}, {
  id: 7,
  name: "MilieuSafe",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604417/img/milieu_safe_partner_logo.png"
}, {
  id: 8,
  name: "CleanRoof",
  logoUrl: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1604417/img/clean_roof_partner_logo.png"
}];
export default function TrustInCollaboration() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="83462" id="vertrouwde-bedrijven" className="bg-[#F8F8F8] py-32 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-8 max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-center font-serif text-[26px] font-bold text-[#182329] mb-16 tracking-tight">Vergelijk alle bedrijven in uw regio!</h2>
        
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-16">
          {clients.map((client, i) => <img key={client.id} data-index={i} src={client.logoUrl} alt={client.name} className="h-7 block grayscale opacity-70 hover:grayscale-0 hover:opacity-100 transition-all duration-300" />)}
        </div>
      </div>
    </section>;
}